import { render } from "./ImageCarousel.vue?vue&type=template&id=5212cd02"
import script from "./ImageCarousel.vue?vue&type=script&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/image-carousel/ImageCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5212cd02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5212cd02', __exports__)) {
    api.reload('5212cd02', __exports__)
  }
  
  module.hot.accept("./ImageCarousel.vue?vue&type=template&id=5212cd02", () => {
    api.rerender('5212cd02', render)
  })

}


export default __exports__